import { Stack, Tab, Tabs, Button, Link as B2BLink, Typography } from '@evaneos/b2b-ui';
import { FormattedMessage } from 'react-intl';
import { NavLink, useLocation } from 'react-router-dom';

import { Processes } from '../../../domain';
import s from '../../../shared/components/layout/ContextualNavbar.module.css';
import { useFiltersDrawer } from '../../../shared/providers/FiltersDrawerContext';
import { useTrackEventAmplitude } from '../../../shared/analytics';
import { parseQueryString } from '../../../shared/utilities/queryString';
import { NavigationToggle } from '../../../shared/components/NavigationToggle';
import { useGetInboxCount } from '../../../resources/inbox/hooks';
import { useHasDossiers } from '../../../resources/dossier-overview/hooks';

export const Navbar = (): JSX.Element => {
    const { openFiltersDrawer } = useFiltersDrawer();
    const location = useLocation();
    const query = parseQueryString(location.search);
    const hasDossiers = useHasDossiers();
    const inboxCount = useGetInboxCount(query);

    const { trackEvent } = useTrackEventAmplitude();

    const handleFilterButtonClicked = () => {
        openFiltersDrawer();
        trackEvent((ampli, defaultProperties) => {
            ampli.rmFilterClicked({
                ...defaultProperties,
                category: 'pipeline',
            });
        });
    };

    const processFromLocation = /\/process\/([^/]+)/.exec(location.pathname)?.[1];
    return (
        <nav className={s.navbarContainer}>
            <Stack direction="row">
                <div className={s.pageSwitch}>
                    <NavigationToggle selected="pipeline" inboxCount={inboxCount} />
                </div>
                <Tabs value={processFromLocation}>
                    {Object.keys(Processes).map((process) => (
                        <Tab
                            disableRipple
                            sx={{
                                textTransform: 'capitalize',
                                color: 'text.primary',
                            }}
                            component={NavLink}
                            key={`processes.${process}.name`}
                            to={{
                                pathname: `/process/${process}`,
                                search: location.search,
                            }}
                            label={process}
                            value={process}
                        />
                    ))}
                </Tabs>
            </Stack>
            <Stack direction="row" gap={2} alignItems="center">
                <Typography variant="body1">
                    <B2BLink data-testid={'cta-agency-capacity'} href="/agency-manager/capacity">
                        Agency capacity
                    </B2BLink>
                </Typography>

                <Button
                    data-testid="process-navbar-filter-button"
                    disabled={!hasDossiers}
                    variant="outlined"
                    onClick={handleFilterButtonClicked}
                >
                    <FormattedMessage id="processes.filters.filters" />
                </Button>
            </Stack>
        </nav>
    );
};
